require('slick-carousel');
import bodymovin from 'lottie-web';
import WOW from "./client-admin-app/wow.min";
import admin from '../../images/lottie/admin.json';
import team from '../../images/lottie/team.json';
import rocket from '../../images/lottie/rocket.json';
import vovason from '../../images/lottie/vovason.json';
import business from '../../images/lottie/business.json';
import report from '../../images/lottie/report.json';


const moreBookingsCarousel = require('../components/moreBookingsCarousel').moreBookingsCarousel;
new moreBookingsCarousel();

let animations = [admin, rocket, team, vovason, business, report];
let animationNames = ['admin', 'rocket' ,'team', 'vovason', 'business', 'report'];
let animation;
let animationData;

for (let i = 0; i < animations.length; i++) {
    let element = document.getElementById(`lottie-${animationNames[i]}`);
    animationData = {
        container: element,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData: animations[i]
    };
    animation = bodymovin.loadAnimation(animationData);
    console.log(animations[i] + ' in ' + element);
}

let $offset = 120;
if ( $(window).width() < 768) {
    $offset = 70;
} else {
    $offset = 120;
}


new WOW({
    offset: $offset
}).init();

var g_heightHeader;
g_heightHeader = $('.header .header--settings-block .header--settings-container').height();

$(window).resize(function () {
    g_heightHeader = $('.header .header--settings-block .header--settings-container').height();
    setHeightForCategoryItem();

    if ( $(window).width() < 768) {
        $offset = 70;
    } else {
        $offset = 120;
    }
});
function setHeightForCategoryItem() {
    let h = $(window).height() - ($('.categories-section .title--h2').outerHeight(true) + g_heightHeader);
    $('.categories-section .categories--row').css({'minHeight': h});
}
setHeightForCategoryItem();

let accordionToggler = $('.hiw--steps-item .hiw--steps-item-toggler').each(function (){
    $(this).on('click', function (e){
        console.log('click')
        e.preventDefault();
        $(this).toggleClass('opened');
        let txtBlock = $(this).closest('.hiw--steps-item').find('.hiw--steps-item-content').toggleClass('full-review');
        $(this).closest('.hiw--steps-item').toggleClass('full-review');

        if ( !$(txtBlock).hasClass("full-review") ) {
            txtBlock.animate({ 'max-height': 1 });
        }  else {
            txtBlock.animate({'max-height': txtBlock[0].scrollHeight + "px"});
        }
    })
})

